module.exports = __webpack_public_path__ + "assets/img/modal-avatar-40d9dca2.png";